import React, {createRef} from "react";

const GameOverlay = ({ onRestart, board, props }) => {
  const inputField = createRef();

  const submitScore = () => {
    const { add2048GameScore } = props;
    let name = inputField.current.value;
    let score = board.score;
  
    if (name && score) {
        const createdAt = new Date().toString(); 
        add2048GameScore({
            name: name,
            score: score,
            createdAt: createdAt,
        });
        inputField.current.value = "";
        onRestart();
    }
  };

  if (board.hasWon()) {
    return <div className="game-2048-tile2048"></div>;
  } else if (board.hasLost()) {
    return (
      <div className="game-2048-gameOver" >
        <div className="game-2048-saveGame">
          <input type="text" placeholder="Enter name here !!!" ref={inputField} name="name" required/>
          <button onClick={() => submitScore()}>SAVE</button>
        </div>
        <img
          src="assets/2048/try-again.gif"
          alt="Try Again!!"
          style={{
            width: "100%",
            height: "100%",
            cursor: "pointer",
          }}
          onClick={onRestart}
        />
      </div>
    );
  }

  return null;
};

export default GameOverlay;